import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from '@bibliocommons/heading';

import { DetailsContainer } from './Details';
import { SubjectAndGenreContainer } from './SubjectAndGenre';
import { ContributorsContainer } from './Contributors';
import { SameSeriesContainer } from './SameSeries';
import { NotesContainer } from './Notes';
import { ContainsContainer } from './Contains';
import './ResearchAbout.scss';

const ResearchAbout = ({ trackFieldItemClick }) => {
  return (
    <section className="cp-bib-research-about container">
      <div className="row">
        <div className="col-lg-3">
          <Heading tagName="h2" size="moderate" variant>
            <FormattedMessage id="about_section" />
          </Heading>
        </div>
        <div className="col-lg-7">
          <SameSeriesContainer />
          <ContributorsContainer trackFieldItemClick={trackFieldItemClick} />
          <ContainsContainer trackFieldItemClick={trackFieldItemClick} />
          <SubjectAndGenreContainer trackFieldItemClick={trackFieldItemClick} />
          <NotesContainer trackFieldItemClick={trackFieldItemClick} />
          <DetailsContainer trackFieldItemClick={trackFieldItemClick} showDetailsMetadata />
        </div>
      </div>
    </section>
  );
};

ResearchAbout.propTypes = {
  trackFieldItemClick: PropTypes.func.isRequired
};

export default ResearchAbout;
